/**
 * Created by CoolGuy on 2017/6/16.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
    } = Ajax;
const TheApi = API('consumer');
const CONSUMER_ADD = "CONSUMER_ADD";
const CONSUMER_LIST = "CONSUMER_LIST";
const CONSUMER_EDIT = "CONSUMER_EDIT";
const CONSUMER_DETAIL = "CONSUMER_DETAIL";
const CONSUMER_DELETE = "CONSUMER_DELETE";
const CONSUMER_CHECK = "CONSUMER_CHECK";
const CONSUMER_ORDERTIME = "CONSUMER_ORDERTIME";

//import {User} from '../util/TestData';
//const mock = User;

export default {
    CONSUMER_ORDERTIME,
    consumerCheckOrderTime:(id)=>{
      return ajaxCommon({
          api:{
              url:'/api/consumer/ordertime',
              method:'get'
          },
          data:{
            id
          },
          success: (data)=>({
              type:CONSUMER_ORDERTIME,
              data
          })
      })
    },
    CONSUMER_CHECK,
    consumerCheck:(obj)=>{
        return ajaxCommon({
            api:{
                url:'/api/consumer/check',
                method:'post'
            },
            data:obj,
            success: (data)=>({
                type:CONSUMER_CHECK,
                data
            })
        })
    },
    CONSUMER_ADD,
    consumerAdd: (one)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:one,
            success: (data)=>({
                type:CONSUMER_ADD,
                data
            })
        })
    },
    CONSUMER_LIST,
    consumers: (search)=>{
        search.page = search.current || 1;//保持antd的风格
        return ajaxCommon({
            //testData:mock.list,
            api:TheApi('get')(),
            data:search,
            success: (data)=>({
                type:CONSUMER_LIST,
                data
            })
        })
    },
    CONSUMER_EDIT,
    consumerEdit: (consumerId,info)=>{
        return ajaxCommon({
            api:TheApi('put')(consumerId),
            data:info,
            success: (data)=>({
                type:CONSUMER_EDIT,
                data
            })
        })
    },
    CONSUMER_DETAIL,
    consumerDetail:(consumerId)=>{
        return ajaxCommon({
            api:TheApi('get')(consumerId),
            success:(data)=>({
                type:CONSUMER_DETAIL,
                consumerId,
                data
            })
        })
    },
    CONSUMER_DELETE,
    consumerDelete:(consumerId)=>{
        return ajaxCommon({
            api:TheApi('delete')(consumerId),
            success:(data)=>({
                type:CONSUMER_DELETE,
                consumerId,
                data
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/ConsumerAction.js